'use client';
import { BadgeProps } from '@/ui-components/atoms/Badge/Badge';
import type { TextTags } from '@/ui-components/atoms/Text/interfaces';
import { ButtonProps } from '@/ui-components/atoms/Button/Button';
import { HeaderCenterOrLeft } from './HeaderCenterOrLeft';
import { HeaderSplit } from './HeaderSplit';

export interface HeaderProps {
    badge?: BadgeProps;
    heading: React.ReactNode;
    headingTag?: TextTags;
    subhead?: React.ReactNode;
    caption?: React.ReactNode;
    channelNumber?: number;
    links?: ButtonProps[];
    ctaGroupAlignment?: 'center' | 'left';
    buttonSubtext?: React.ReactNode;
    theme?:
        | 'center'
        | 'full-width-center'
        | 'left'
        | 'buttons-left-text-right'
        | 'text-left-buttons-right'
        | 'always-left';
    inheritTextColor?: boolean;
    subHeadAbove?: boolean;
    className?: string;
    headingAriaLabel?: string;
    type?: 'promoBanner' | 'promoBannerCard' | 'heroHeader';
    isInHorizontallyRenderedGroup?: boolean;
}

export function Header({
    theme = 'center',
    type,
    isInHorizontallyRenderedGroup = false,
    headingTag,
    ...rest
}: HeaderProps): React.JSX.Element {
    let headerTheme = theme;
    let headingTagPromoBanner = headingTag;
    if (type === 'promoBanner') {
        headerTheme = headerTheme !== 'text-left-buttons-right' ? headerTheme : 'text-left-buttons-right';

        headingTagPromoBanner = 'h2';
    } else if (type === 'promoBannerCard') {
        headerTheme = 'left';
        headingTagPromoBanner = 'h2';
    }

    const isCenterOrLeft = headerTheme === 'center' || headerTheme === 'full-width-center' || headerTheme === 'left';
    const props = {
        theme: headerTheme,
        headingTag: headingTagPromoBanner,
        type,
        isInHorizontallyRenderedGroup,
        ...rest,
    };

    return isCenterOrLeft ? <HeaderCenterOrLeft {...props} /> : <HeaderSplit {...props} />;
}
